import React, { useEffect, useState } from 'react';
import { AccordionSection as AccordionSectionComponent } from './AccordionSection';
import { Wrapper } from './styles';
import { dasherize } from "../../../helpers/dasherize";
let windowHelper = window;
export const Accordion = ({ content, drawOpen }) => {
    const [openSection, setOpenSection] = useState('');
    useEffect(() => {
        if (drawOpen && content.length > 0) {
            setOpenSection(content[0].name);
        }
    }, []);
    return (React.createElement(Wrapper, null, content.map((section, i) => {
        if (section.hidden) {
            return null;
        }
        const isOpen = section.name === openSection;
        return (React.createElement(AccordionSectionComponent, { key: i, title: section.title, shield: section.shield, content: section.content, isOpen: isOpen, toggleOpen: () => {
                if (isOpen) {
                    setOpenSection('');
                }
                else {
                    setOpenSection(section.name);
                    windowHelper._uxa.push(['setQuery', window.location.search + (window.location.search.indexOf('?') === -1 ? '?' : '&') + `view=${dasherize(section.name)}`]);
                    windowHelper._uxa.push(['trackPageview',]);
                }
            } }));
    })));
};
Accordion.defaultProps = {};
